export default __webpack_public_path__ + "static/media/Person Icon.e4683714.svg";